import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { search: String };

  static targets = ['highlight'];

  connect() {
    if (!this.searchValue) {
      return;
    }
    this.highlight();
  }

  disconnect() {
    this.unhighlight();
  }

  searchValueChanged() {
    this.unhighlight();
    if (this.searchValue) {
      this.highlight();
    }
  }

  unhighlight() {
    this.element.innerHTML = this.element.innerHTML.replace(/<mark>/gi, '');
    this.element.innerHTML = this.element.innerHTML.replace(/<\/mark>/gi, '');
  }

  highlight() {
    const words = this.searchValue.split(' ');

    words.forEach((word) => {
      this.element.innerHTML = this.element.innerHTML.replace(
        new RegExp(word, 'gi'),
        (match) => `<mark>${match}</mark>`,
      );
    });
  }
}
